import { USER_NOTE_CREATE, USER_NOTE_GET } from '@/data/url'
import apiClient from '@/services/apiClient'
import { unwrapApiData } from '@/services/apiEnvelope'

const createUserNote = async (noteData) => {
    try {
        const response = await apiClient.post(USER_NOTE_CREATE, noteData)
        return unwrapApiData(response, null)
    } catch (error) {
        console.error('Error saving note:', error)
        return null
    }
}

const getUserNotes = async (
    partsText, 
    searchCustomer, 
    searchActionId
) => {
    let jsonPost = {
        part_number: partsText,
        customer: searchCustomer,
        search_action_id: searchActionId,
    }

    try {
        const response = await apiClient.post(USER_NOTE_GET, jsonPost)
        return unwrapApiData(response, null)
    } catch (error) {
        console.error('Error fetching notes:', error)
        return null
    }
}

export default {
    createUserNote,
    getUserNotes,
}
